import {CircularProgress, useTheme} from "@material-ui/core";
import {Typography} from "../Wrappers";
import React from "react";
import useStyles from "./styles";

export default (props) => {
    const classes = useStyles(useTheme())
    if (props.showProgress) {
        return (
            <div className={classes.container}>
                <div className={classes.message}>
                    <Typography>{props.progressMessage ? props.progressMessage : "Loading, please wait..."}</Typography>
                </div>
                <div>
                    <CircularProgress/>
                </div>
            </div>
        )
    } else {
        return props.children
    }
}